import foodSolutionContent from './food-solution-content'
import portfolio from './portfolio'
import team from './team'
import transfer from './transfer'

export default (ctx, inject) => {
  const services = {
    foodSolutionContent: foodSolutionContent(ctx),
    portfolio: portfolio(ctx),
    team: team(ctx),
    transfer: transfer(ctx),
  }

  inject('services', services)
}
